// extracted by mini-css-extract-plugin
export var closeButton = "_du-1";
export var closeX = "_du-3";
export var container = "_du-0";
export var image = "_du-2";